module.exports = __webpack_public_path__ + "html/autoscout24.template.html";